import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useI18n } from '../i18n/index.jsx';

const PaginationControls = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  widgetType,
  onPageChange,
  className = '',
}) => {
  const { t } = useI18n();
  const startIndex = currentPage * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  if (totalItems === 0) {
    return null;
  }

  return (
    <div className={`pagination-controls ${className}`}>
      <div className="pagination-controls__content">
        <div className="pagination-controls__type">{widgetType}</div>
        <div className="pagination-controls__buttons">
          <button
            className={`pagination-controls__btn ${currentPage === 0 ? 'pagination-controls__btn--hidden' : ''}`}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 0}
            aria-label={t('previous_page')}
          >
            <ChevronLeft className="sb-flip-rtl" />
          </button>
          <div className="pagination-controls__counter">
            {t('pagination_range', { start: startIndex + 1, end: endIndex, total: totalItems })}
          </div>
          <button
            className={`pagination-controls__btn ${currentPage === totalPages - 1 ? 'pagination-controls__btn--hidden' : ''}`}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages - 1}
            aria-label={t('next_page')}
          >
            <ChevronRight className="sb-flip-rtl" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaginationControls;
